import { EditStore } from "../EditCreate/EditStore";
import { DivisionDraft, Division } from "../../../../models/Division";
import { names } from "./EditCreateDivisionActions";
import { names as editCreateNames } from "../../../actions/EditCreateEntityActions";
import { EntityType } from "../../../../models/EntityType";
import { prepareDivisionDraft } from "../../../utils/draft";

export class EditCreateDivisionStoreState
{
    draft: DivisionDraft;
    divisions: Division[];
}

// This Flux store holds a draft of the changes as well as possible values for division selector
export class EditCreateDivisionStore extends EditStore<DivisionDraft, EditCreateDivisionStoreState>
{
    constructor()
    {
        super();
        this.state = this.getDefaultStateFor(null);
        
        this.register<string>(names.SET_NAME, e => this.draft({ Name: e.payload }));
        this.register<number>(names.SET_PARENT_DIVISION, e => this.draft({ ParentId: e.payload }));
        this.register<Division[]>(names.SET_DIVISION_ITEMS, e => this.field({ divisions: e.payload }));
        this.register(editCreateNames.REJECT_DRAFT, e => {
            if(e.meta === EntityType.Division)
                return this.getDefaultStateFor(null);
        });
        this.register<Division>(editCreateNames.SET_EDIT_ENTITY, e => {
            if(e.meta === EntityType.Division)
                return this.getDefaultStateFor(e.payload);
        });
    }

    private getDefaultStateFor(division: Division): EditCreateDivisionStoreState
    {
        return {
            draft: prepareDivisionDraft(division),
            divisions: [],
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Division/EditCreateDivisionStore.ts